import { Agent } from '@propertypal/shared/src/types/agents';
import React, { CSSProperties, FunctionComponent } from 'react';
import Chevron from '../icons/Chevron';
import { AgentName, BackLink, Container } from './AgentsBox.style';

interface Props {
  containerStyle?: CSSProperties;
  agents?: Agent[];
  align: 'left' | 'center';
  backgroundColor?: string;
  onBackClick?: () => void;
}

const AgentsBox: FunctionComponent<Props> = (props) => {
  if (!props.agents || !props.agents.length) {
    return null;
  }

  return (
    <Container align={props.align} backgroundColor={props.backgroundColor} style={props.containerStyle}>
      {props.agents.map((agent) => {
        if (agent.logo) {
          return (
            <img
              key={agent.accountNumber}
              src={agent.logo.standard}
              style={{ maxHeight: 40, marginRight: 10 }}
              alt="logo"
              data-testid="agent-logo"
            />
          );
        }

        return (
          <AgentName key={agent.accountNumber}>
            <p>{agent.organisation}</p>
          </AgentName>
        );
      })}

      {props.onBackClick && (
        <BackLink onClick={props.onBackClick} type="button">
          <Chevron direction="left" size={10} /> back to agent selection
        </BackLink>
      )}
    </Container>
  );
};

export default AgentsBox;
